import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useFormik } from 'formik';
import { translatedMessage } from '../../service/LanguageService';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { CompetitionService } from '../../service/CompetitionService';
import GeneralUtils from '../../utilities/GeneralUtils';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';

const defaulNewValue = {
    id: null,
    bibliography: '',
    topic: '',
}

const CompetitionBibliographyEditDialog = (props) => {
    const [bibliography, setBibliography] = useState({});
    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        // console.log("props: ", props)
        let _bibliography = props.bibliography ? props.bibliography : { ...defaulNewValue, competition: { id: props?.competition?.id } }
        setBibliography(_bibliography);

    }, [props]);

    // Form
    const formik = useFormik({
        initialValues: bibliography,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};

            // console.log("validate: ", data)

            if (!data.bibliography || data.bibliography.trim() === '') {
                errors.bibliography = translatedMessage("form.error.competition.bibliography.required");
            }

            if (!data.topic || data.topic.trim() === '') {
                errors.topic = translatedMessage('form.error.competition.topic.required');
            }


            return errors;
        },
        onSubmit: (data) => {
            let _data = { ...GeneralUtils.nullIfEmptyForObjectFields(data) };
            _data.competition = { id: data.competition.id }

            // console.log("saved data: ", _data)

            competitionService.saveCompetitionBibliography(_data)
                .then(savedBibliography => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(savedBibliography, true);
                    }
                    handleDialogClose()
                })
                .catch(error => {
                    if (typeof props.afterSave === 'function') {
                        props.afterSave(null, false, error);
                    }
                });
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage("generic.cancel")} icon="pi pi-times" className="p-button-text" onClick={() => handleDialogClose()} />
            <Button label={translatedMessage("generic.save")} icon="pi pi-check" className="p-button-text" form="bibliography-form" type="submit" />
        </>
    )

    const handleDialogClose = () => {
        props.onClose()
        formik.resetForm()
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={props.visible}
                closable={true}
                onHide={handleDialogClose}
                header={translatedMessage("competition.requirements.bibliography.title")}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
            >
                <form id="bibliography-form" onSubmit={formik.handleSubmit}>
                    <div className="input-panel flex flex-column mb-5">
                        <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <InputText type="text" name="bibliography" id="bibliography"
                                    value={formik.values.bibliography} onChange={formik.handleChange} autoFocus
                                    className={classNames({ 'p-invalid': isFormFieldValid('bibliography') })} />
                                <label htmlFor="bibliography" className={classNames({ 'p-error': isFormFieldValid('bibliography') })}>
                                    {translatedMessage("competition.requirements.bibliography")} *
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('bibliography')}

                        <div className="p-inputgroup mt-3">
                            <span className="p-float-label">
                                <InputTextarea type="topic" id="topic" name="topic" value={formik.values?.topic}
                                    onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('topic') })}
                                    rows={5} cols={30} autoResize
                                    maxLength={10000}
                                    tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                    tooltipOptions={{ position: 'top' }} />
                                <label htmlFor="topic" className={classNames({ 'p-error': isFormFieldValid('topic') })}>
                                    {translatedMessage("competition.requirements.topic")} *
                                </label>
                            </span>
                        </div>
                        {getFormErrorMessage('topic')}
                    </div>
                </form>
            </Dialog>
        </>
    );
};

export default CompetitionBibliographyEditDialog;
